import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { ApiCallsService } from '../../../shared/services/network/api-calls.service';
import { SafeHtmlPipe } from '../../../shared/validators/safe-html.pipe';
import { EMAIL_REGEX, MOBILE_REGEX } from '../../../utils/constants';
import { ICONS } from '../../../utils/svg-icons';
@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
  imports: [ReactiveFormsModule, CommonModule, RouterLink, SafeHtmlPipe],
})
export class LoginPageComponent implements OnInit {
  showError: boolean = false;
  isPasswordVisible: boolean = false;
  loginForm!: FormGroup;
  isLoading: boolean = false;
  disableLogin: boolean = false;
  errorTime = 0;
  ICONS = ICONS;
  constructor(
    private _admin: ApiCallsService,
    private _auth: AuthService,
    private _formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    const MOBILE_REGEX_PATTERN = new RegExp(MOBILE_REGEX);
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, this.atLeastOnePatternValidator([EMAIL_REGEX, MOBILE_REGEX_PATTERN])]],
      password: ['', Validators.required],
      // phoneNumber: [''],
      deviceToken: ['tokekn'],
      userType: ['user'],
      rememberMe: [false],
    });
    this.loginForm.patchValue(this._auth.credentials);
  }

  onLogin(): void {
    if (this.loginForm.invalid) {
      this.showValidationMessage();
      return;
    }
    // this.loginForm.patchValue({ tzOffset: this._auth.tzOffset() });
    this.loginForm.patchValue({ deviceToken: this._auth.deviceToken() });
    this.isLoading = true;
    this._auth.login(this.loginForm.value).catch((err: any) => {
      if (err?.error?.statusCode == 401) {
        this.errorTime = this.errorTime + 1;
        if (this.errorTime > 5) {
          this._admin.errorAlert('Too many failed login attempts. Please try again later.', true, '', err);
          this.disable();
        }
      }
      this.isLoading = false;
    });
  }
  disable() {
    this.disableLogin = true; // Disable the login button
    setTimeout(() => {
      this.errorTime = 0;
      this.disableLogin = false; // Re-enable after timeout
    }, 60000); // Match lock time
  }
  private showValidationMessage(): void {
    const validationMessageDuration = 5000;
    this.showError = true;
    setTimeout(() => (this.showError = false), validationMessageDuration);
  }
  keyUpValue() {
    const MOBILE_REGEX_PATTERN = new RegExp(MOBILE_REGEX);
    return MOBILE_REGEX_PATTERN.test(this.loginForm.value.email);
  }
  atLeastOnePatternValidator(patterns: RegExp[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return { required: true }; // Handle required validation
      }

      const isAnyPatternValid = patterns.some((pattern) => pattern.test(value));
      return isAnyPatternValid ? null : { atLeastOnePatternInvalid: true };
    };
  }
}
